<template>
    <div class="content" :style="{ height: screenHeight + 'px' }">
        <div class="icon-box">
            <img class="icon" src="../../assets/theme/light/third/01aswear/01bdIcon.png" alt="">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
            <img class="icon" src="../../assets/theme/light/third/01aswear/02yujinxiang.png" alt="">
        </div>
        <div class="text">与Aswear联接</div>
        <div class="btn">联接Aswear</div>
    </div>
</template>

<script>
export default {
    name: 'aswear',
    data() {
        return {
            screenHeight: window.innerHeight
        }
    },
    mounted() {
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        // 移除事件监听
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.screenHeight = window.innerHeight;
        }
    }
}
</script>

<style scoped>
.content {
    background-color: #383838;
    width: 100%;
}

.icon-box {
    display: flex;
    justify-content: center;
    padding-top: 100px;
    align-items: center;
}

.icon {
    width: 50px;
    border-radius: 10px;
}

.bar1 {
    width: 10px;
    height: 10px;
    background-color: var(--chart-color-1);
    border-radius: 50%;
    margin: 0 10px;
}

.bar2 {
    width: 10px;
    height: 10px;
    background: linear-gradient(to right, var(--chart-color-1), #e9662d);
    border-radius: 50%;
    margin: 0 10px;
}

.bar3 {
    width: 10px;
    height: 10px;
    background-color: #e9662d;
    border-radius: 50%;
    margin: 0 10px;
}

.text {
    font-size: 18px;
    text-align: center;
    margin-top: 50px;
}

.text {
    width: 150px;
    background-color: #e9662d;

}
</style>



// WEBPACK FOOTER //
// src/views/third/01aswear.vue